import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HTTP } from '@ionic-native/http/ngx';
import { Storage } from "@ionic/storage";
import * as CryptoJS from 'crypto-js';
import { RequestModelService } from '../request/request-model.service';
import { Router } from '@angular/router';
import { GenericService } from '../../generic.service';

declare var window;
declare var gapi: any;

// @Injectable()
@Injectable({
  providedIn: 'root'
})
export class HmclService {

  // url="https://hmclmobazfun02p-staging.azurewebsites.net/api/cloudware_prod?ORG_ID=HTA"
  url= "https://prod-apim.heromotocorp.com/sharedApiT1/cloudware_prod?ORG_ID=HTA" //NEW LANDING ZONE PRODUCTION
  // url = "https://uat-apim.heromotocorp.com/sharedApiT1/cloudware_prod?ORG_ID=HTA" //NEW LANDING ZONE UAT

 
  productionUrl: boolean = false;
  retailerCode: string = "";
  token: string = "";
  constructor(private http: HttpClient,private storage:Storage,
    private request: RequestModelService,
    private router:Router,
    private genericService:GenericService,
  
    private http2: HTTP) { }



  ApiMapping = {

'MB_Authentication_gmail':'MB_Authentication_gmail',
'MB_REFRESH_TOKEN':'MB_REFRESH_TOKEN',
'get_questions':'get_questions',
'portal_logout':'portal_logout',
'RFCCALL':'RFCCALL'
  }

  ReverseApiMapping = {
  'MB_Authentication_gmail':'MB_Authentication_gmail',
  'MB_REFRESH_TOKEN':'MB_REFRESH_TOKEN',
  'get_questions':'get_questions',
  'portal_logout':'portal_logout',
  'RFCCALL':'RFCCALL'

  };

  ApiMapping_callType = {
    'MB_Authentication_gmail':'17',
    'MB_REFRESH_TOKEN':'24',
    'get_questions':'1',
    'portal_logout':'1',
    'RFCCALL':'3'

  };    

  CallApi(body, token, auth_type_value) {


    var process_id = body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID;


    if (process_id == this.ApiMapping.MB_Authentication_gmail) {

      var headers = { "Content-Type": "application/json"};
      body.PWSESSIONRS.PWPROCESSRS.PWHEADER.LOGIN_ID = auth_type_value;
      return this.CallApiFinal(body, headers);

    }else if(process_id == this.ApiMapping.MB_REFRESH_TOKEN){
      var access_token = "Bearer " + token;
      var header = { "Content-Type": "application/json", 'Authorization': access_token };
      body.PWSESSIONRS.PWPROCESSRS.PWHEADER.LOGIN_ID = auth_type_value;
      return this.CallApiFinal(body, header);
    }
    else {
      
     var tokentemp = "Bearer " + token;
     

      var header = { "Content-Type": "application/json", 'Authorization': tokentemp };
      // var headers = new HttpHeaders({ "Content-Type": "application/json", "Authorization": tokentemp });
      body.PWSESSIONRS.PWPROCESSRS.PWHEADER.LOGIN_ID = auth_type_value;
      return this.CallApiFinal(body, header);
    }


    // var url = "http://10.200.2.231/PlatwareAnalyzer_03_01_65_uat/GatewayAnalyserJson?ORG_ID=HMM";
  }

  CallApi3(body, token, auth_type_value) {




    var process_id = body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID;

 
    if (process_id == this.ApiMapping.MB_Authentication_gmail) {
      var headers = new HttpHeaders({ "Content-Type": "application/json" });
      body.PWSESSIONRS.PWPROCESSRS.PWHEADER.LOGIN_ID = auth_type_value;
      return this.CallApiFinal(body, headers);

    }
    else {
      var tokentemp = token + "::" + auth_type_value + "::HSLP";
    

      tokentemp = "Basic " + btoa(tokentemp);
     
          


      var headers = new HttpHeaders({ "Content-Type": "application/json", "Authorization": tokentemp });
      body.PWSESSIONRS.PWPROCESSRS.PWHEADER.LOGIN_ID = auth_type_value;
      return this.CallApiFinal2(body, headers);
    }
  

  }


  CallApiFinal2(body, headers) {
  //  var url = "https://mobileapps01.heromotocorp.com/cloudware_uat/GatewayAnalyserJson?ORG_ID=HSLP";

    body.PWSESSIONRS.PWPROCESSRS.PWHEADER.IN_PROCESS_ID = this.ApiMapping_callType[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID] || "";
    //to manage request sequence
    let row_length = body.PWSESSIONRS.PWPROCESSRS.PWDATA[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID].Row.length;
    let keys = row_length > 0 ? Object.keys(body.PWSESSIONRS.PWPROCESSRS.PWDATA[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID].Row[0]) : [];
    let orderedData = {};
    let unorderedData = row_length > 0 ? body.PWSESSIONRS.PWPROCESSRS.PWDATA[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID].Row[0] : {};
    // addding numbers before key to maintain sequesnce on server 
    for (var i = 0; i < keys.length; i++) {
      orderedData[i] = unorderedData[keys[i]];
    }
    body.PWSESSIONRS.PWPROCESSRS.PWDATA = {};
    body.PWSESSIONRS.PWPROCESSRS.PWDATA[this.ApiMapping[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID]] = {}
    body.PWSESSIONRS.PWPROCESSRS.PWDATA[this.ApiMapping[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID]].Row = [];
    body.PWSESSIONRS.PWPROCESSRS.PWDATA[this.ApiMapping[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID]].Row.push(orderedData);

    body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID = this.ApiMapping[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID];

    this.http2.setDataSerializer("json");
    return this.http.post(this.url, body, headers);
  }




  CallApiFinal(body, headers) {

    body.PWSESSIONRS.PWPROCESSRS.PWHEADER.IN_PROCESS_ID = this.ApiMapping_callType[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID] || "";

    let row_length = body.PWSESSIONRS.PWPROCESSRS.PWDATA[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID].Row.length;
    let keys = row_length > 0 ? Object.keys(body.PWSESSIONRS.PWPROCESSRS.PWDATA[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID].Row[0]) : [];
    let orderedData = {};
    let unorderedData = row_length > 0 ? body.PWSESSIONRS.PWPROCESSRS.PWDATA[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID].Row[0] : {};
   
    for (var i = 0; i < keys.length; i++) {
      orderedData[i] = unorderedData[keys[i]];
    }
    body.PWSESSIONRS.PWPROCESSRS.PWDATA = {};
    body.PWSESSIONRS.PWPROCESSRS.PWDATA[this.ApiMapping[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID]] = {}
    body.PWSESSIONRS.PWPROCESSRS.PWDATA[this.ApiMapping[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID]].Row = [];
    body.PWSESSIONRS.PWPROCESSRS.PWDATA[this.ApiMapping[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID]].Row.push(orderedData);

    body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID = this.ApiMapping[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID];




      return this.http.post(this.url, body, { headers: headers })
    
 

  }

  call_MB_REFRESH_TOKEN(email){


    this.storage.get("truck_audit_user_data").then((user_token) => {
          let REQ_DATA = this.request.getStaticRequestData();
          REQ_DATA.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID = this.ApiMapping.MB_REFRESH_TOKEN;
          let PWDATA = this.request.sample_MB_REFRESH_TOKEN();
          PWDATA.MB_REFRESH_TOKEN.Row[0].user_id = email;
    
          REQ_DATA.PWSESSIONRS.PWPROCESSRS.PWDATA = PWDATA;
    
         this.CallApi(REQ_DATA,user_token.token.access_token, email).subscribe((data: any) => {
    
            var refresh_token_data = data.PWSESSIONRS[0].PWPROCESSRS.PWDATA.MB_REFRESH_TOKEN.Row[0];
           
     
        
            if(refresh_token_data.success=='1')
            {
            
            //  let encrytpedData = JSON.stringify(this.genericService.encrypt(this.loginObj));
              this.storage.set("truck_audit_user_data",refresh_token_data).then(() => {
    
    
              });
              this.router.navigate(['/home'])
            }
     
        }, (err) => {
          if (err.status === 403) {
    
          
            // var auth2 = gapi.auth2.getAuthInstance();
            // auth2.signOut().then(function () {
            //   this.logout(email);
             
            // });
            // auth2.disconnect();
            localStorage.clear();
            this.genericService.presentAlert("Session Invalidated!", "You have been logged out.");
            this.router.navigateByUrl('login');
            
          }
        })
      });
      }

      logout(email){


        this.storage.get("truck_audit_user_data").then((user_token) => {
              let REQ_DATA = this.request.getStaticRequestData();
              REQ_DATA.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID = this.ApiMapping.portal_logout;
              let PWDATA = this.request.sample_portal_logout();
              PWDATA.portal_logout.Row[0].user_id = email;
        
              REQ_DATA.PWSESSIONRS.PWPROCESSRS.PWDATA = PWDATA;
        
             this.CallApi(REQ_DATA,user_token.token.access_token, email).subscribe((data: any) => {
        
                var logout = data.PWSESSIONRS[0].PWPROCESSRS.PWDATA.portal_logout.Row;
               
         
            
              
         
            }, (err) => {
              if (err.status === 403) {
        
               
                // var auth2 = gapi.auth2.getAuthInstance();
                // auth2.signOut().then(function () {
                 
                // });
                // auth2.disconnect();
                // localStorage.clear();
                // this.genericService.presentAlert("Session Invalidated!", "You have been logged out.");
                // this.router.navigateByUrl('login');
                
              }
            })
          });
          }

  CallApi2(body) {
    var url = "";
    // var url = "http://10.200.2.231/PlatwareAnalyzer_03_01_65_uat/GatewayAnalyserJson?ORG_ID=HMM";
    var headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post(url, body, { headers: headers });

  }
  getDataByURL(url) {
   
    var headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.get(url,{ headers: headers });

  }
  callapiforrfc(body,token, auth_type_value) {
  
    body.PWSESSIONRS.PWPROCESSRS.PWHEADER.IN_PROCESS_ID = this.ApiMapping_callType[body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID] || "";
    var tokentemp = "Bearer " + token;
     

    var headers = { "Content-Type": "application/json", 'Authorization': tokentemp };

        
    body.PWSESSIONRS.PWPROCESSRS.PWHEADER.LOGIN_ID = auth_type_value;
   
   
    return this.http.post(this.url, body, { headers: headers });
  }
  GetVideos(body, token, email) {

    var process_id = body.PWSESSIONRS.PWPROCESSRS.PWHEADER.OUT_PROCESS_ID;
    var headers = new HttpHeaders({ "Content-Type": "application/json" });
    var tokentemp = token + "::" + email + "::technician";
    tokentemp = "Basic " + btoa(tokentemp);

    var headers = new HttpHeaders({ "Content-Type": "application/json", "Authorization": tokentemp });
    body.PWSESSIONRS.PWPROCESSRS.PWHEADER.LOGIN_ID = email;
    return this.CallApiFinal(body, headers);
  }

  encrypt(data) {
    var key = "qwertyuiopasdfg";
    return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
    
  }
  
  decrypt(data) {
    var key = "qwertyuiopasdfg";
    let bytes = CryptoJS.AES.decrypt(data, key);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
 
  }


  encrypteTheRequest(data)
  {
    
    var key = CryptoJS.enc.Utf8.parse('dxgbfh35436dgfghgjdgfhwqwqwqwqwq');
    var iv = CryptoJS.enc.Utf8.parse('gdqy4kl2scvg9tqw');
    var text = data;
    
    var encrypted = CryptoJS.AES.encrypt(text, key, {
      keySize: 256 / 8,
      mode: CryptoJS.mode.CBC,
      iv:iv,
      padding: CryptoJS.pad.Pkcs7
      });
      
    return encrypted;
  }


  decrypteTheRequest(encrypteddata)
  {
    
    var key = CryptoJS.enc.Utf8.parse('dxgbfh35436dgfghgjdgfhwqwqwqwqwq');
    var iv = CryptoJS.enc.Utf8.parse('gdqy4kl2scvg9tqw');

      
      var decrypted = CryptoJS.AES.decrypt(encrypteddata, key, {
      keySize: 256 / 8,
      mode: CryptoJS.mode.CBC,
      iv:iv,
      padding: CryptoJS.pad.Pkcs7
      });
      
      return decrypted.toString(CryptoJS.enc.Utf8);
  }



}
